import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { finalize, Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
  providers: [MessageService, DialogService],
})
export class ResetPasswordComponent {
  resetPasswordForm: FormGroup;
  errorMessage: string | null = null;
  isLoading$: Observable<boolean>;
  isSubmitting = false;
  hidePassword = true;
  token: string = '';

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private dialogService: DialogService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.isLoading$ = this.authService.isLoading$;
    this.resetPasswordForm = this.fb.group({
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,15}$/),
        ],
      ],
    });
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.params['random'];
    console.log('Token capturado:', this.token);

    if (this.token) {
      this.validateToken();
    } else {
      this.errorMessage = 'Token no encontrado o inválido.';
      setTimeout(() => {
        this.router.navigate(['/auth/login']);
      }, 2000);
    }
  }

  validateToken(): void {
    this.authService
      .getCheckRandom(this.token)
      .pipe(
        finalize(() => {
          console.log('Validación de token completada');
        })
      )
      .subscribe({
        next: (response) => {
          if (response.status === 200) {
            console.log('Token válido (200 OK):', response);
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'asdas',
            });
            // this.router.navigate(['/auth/login']);
          }
        },
        error: (error) => {
          console.error('Error validando token:', error);
          this.errorMessage = 'Token inválido o expirado';
          setTimeout(() => {
            this.router.navigate(['/auth/login']);
          }, 2000);
        },
      });
  }

  onSubmit() {
    if (this.resetPasswordForm.valid) {
      this.isSubmitting = true;
      const { password } = this.resetPasswordForm.value;
      console.log('Token a enviar:', this.token);

      this.authService.resetPassword(this.token, password).subscribe({
        next: (response) => {
          if (response) {
            setTimeout(() => {
              this.router.navigate(['/auth/login']);
            }, 1500);
          }
        },
        error: (error) => {
          this.errorMessage =
            error.error?.message || 'Error al restablecer la contraseña';
          this.isSubmitting = false;
        },
      });
    } else {
      this.errorMessage = 'Por favor, complete todos los campos.';
    }
  }
}
